import {certificateElementType} from "~/enums/certificateElementType";
import DynamicModeCertificateElement from "./dynamicCertificateElement";
import DynamicListElement from "./concerns/dynamicListElement";
import {HorizontalAlignment} from "~/enums/certificates/alignment";

export default class DynamicModeDynamicListCertificateElement extends DynamicListElement(DynamicModeCertificateElement) {
  type: certificateElementType = certificateElementType.DynamicModeDynamicList;

  htmlStyles(): string{
    let baseStyles = super.htmlStyles()
    let textAlign
    switch(this.horizontal_alignment){
      case HorizontalAlignment.Left:
        textAlign= "left"
        break;
      case HorizontalAlignment.Middle:
        textAlign = "center"
        break;
      case HorizontalAlignment.Right:
        textAlign = "right"
        break
    }
    baseStyles += ` text-align: ${textAlign};`
    return baseStyles
  }
}